import { Box, LinearProgress, Typography, useTheme } from "@mui/material";

import { TArtifact } from "../../types";
import { blue } from "@mui/material/colors";
import { snakeToTitleCase } from "src/reusable/Functions";

type TArtifactProgressAlert = {
  isLoading: boolean;
  currentArtifact: TArtifact | undefined;
};

const ArtifactProgressAlert = ({
  isLoading,
  currentArtifact,
}: TArtifactProgressAlert) => {
  const theme = useTheme();

  return (
    <>
      {isLoading && (
        <Box
          sx={{
            borderBottom: `1px solid ${theme.palette.divider}`,
            bgcolor: blue[50],
          }}
        >
          <LinearProgress color="info" />
          <Box sx={{ px: 2, py: 1.5 }}>
            <Typography variant="body1">
              {`${snakeToTitleCase(
                currentArtifact?.type,
              )} generation in progress...`}
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ArtifactProgressAlert;
